/**
 * Swatch Color Generator
 * Colors pulled from Shopify Color Pattern metaobjects
 * Last updated: December 2024
 */
(function() {
  'use strict';

  // Complete color list from metaobjects
  const swatchColors = {
    "304-stainless-steel": "#C0C0C0",
    "agata": "#D0D0D0",
    "aged-brass": "#D4AF37",
    "aged-bronze": "#8B4513",
    "aged-iron-pvd": "#808080",
    "almond-ivory-and-gold-trim": "#F5F5DC",
    "almond": "#B4AAA2",
    "alpina": "#FFFFFF",
    "anthracite": "#001F5B",
    "anthracite-satin": "#001F5B",
    "antique-brass-p-v-d": "#CD7F32",
    "antique-brass-pvd": "#CD7F32",
    "arctic-white": "#FFFFFF",
    "artisan-copper": "#CD7F32",
    "basento": "#F5F5DC",
    "black": "#000000",
    "black-copper": "#000000",
    "black-gold": "#8B4513",
    "black-rose-gold": "#000000",
    "black-white": "#808080",
    "black-chrome": "#000000",
    "black-chrome-and-relative": "#000000",
    "black-granite": "#000000",
    "black-metal": "#000000",
    "black-metal-brushed": "#000000",
    "black-metal-p-v-d": "#000000",
    "black-metal-pvd": "#000000",
    "black-onyx": "#000000",
    "black-pearl": "#000000",
    "black-steel": "#001F5B",
    "black-w-chrome-buttons": "#000000",
    "black-walnut": "#000000",
    "black-chrome": "#000000",
    "blanc": "#FFFFFF",
    "blue": "#005BD3",
    "bronze": "#CD7F32",
    "brown": "#9A5630",
    "brushed": "#C0C0C0",
    "brushed-black": "#000000",
    "brushed-black-metal": "#000000",
    "brushed-brass": "#D4AF37",
    "brushed-brass-pvd": "#CD7F32",
    "brushed-brass-black": "#D4AF37",
    "brushed-bronze": "#CD7F32",
    "brushed-carbon": "#000000",
    "brushed-chrome": "#D0D0D0",
    "brushed-copper": "#8B4513",
    "brushed-gold": "#D4AF37",
    "brushed-gold-pvd": "#D4AF37",
    "brushed-gun-metal": "#868383",
    "brushed-gunmetal": "#868383",
    "brushed-gun-metal-pvd": "#808080",
    "brushed-gunmetal-pvd": "#808080",
    "brushed-nickel": "#C0C0C0",
    "brushed-nickel-ex-display": "#D0D0D0",
    "brushed-nickel-pvd": "#C0C0C0",
    "brushed-nordic-brass": "#D4AF37",
    "brushed-nordic-brass-pvd": "#C0C0C0",
    "brushed-raw-brass": "#D4AF37",
    "brushed-rose-gold": "#CA989F",
    "brushed-rose-gold-pvd": "#B76E79",
    "brushed-stainless": "#C0C0C0",
    "brushed-stainless-steel": "#C0C0C0",
    "brushed-stainless-steel-raw": "#C0C0C0",
    "brushed-steel": "#C0C0C0",
    "brushed-swiss-brass-pvd": "#D4AF37",
    "brushed-warm-bronze-pvd": "#8B4513",
    "brushed-warm-steel": "#C0C0C0",
    "burgundy": "#8B4513",
    "champagne": "#F5F5DC",
    "charcoal": "#000000",
    "chrome": "#C0C0C0",
    "chrome-black-and-relative": "#C6C4C4",
    "chrome-black": "#C6C4C4",
    "chrome-white": "#D0D0D0",
    "chrome-gold": "#FFFFFF",
    "classic-gold": "#C2AD31",
    "clay": "#8B4513",
    "coco-brown": "#8B4513",
    "concrete": "#C0C0C0",
    "concrete-black": "#000000",
    "cool-grey-30": "#C0C0C0",
    "cool-grey-70": "#808080",
    "cool-grey-90": "#B6B9BD",
    "copper": "#CD7F32",
    "copper-pvd": "#CD7F32",
    "croma": "#C0C0C0",
    "dark-grey": "#001F5B",
    "deep-blue-black": "#000000",
    "durobrite-chrome": "#C0C0C0",
    "dusk": "#808080",
    "eureka-gold": "#D4AF37",
    "forest": "#008000",
    "fucile": "#808080",
    "geometric": "#808080",
    "glacier-white": "#FFFFFF",
    "gloss-alpine-white": "#FFFFFF",
    "gloss-black": "#000000",
    "gloss-white": "#FFFFFF",
    "gold": "#D49A06",
    "graphite": "#001F5B",
    "green": "#05AA3D",
    "grey": "#808080",
    "gray": "#808080",
    "grey-wolf": "#808080",
    "gun-metal": "#808080",
    "gunmetal": "#5E6064",
    "gun-metal-grey": "#808080",
    "gunmetal-grey": "#676A6E",
    "industrial": "#808080",
    "ivory": "#FFFFFF",
    "ivory-chrome": "#F5F5DC",
    "ivory-gold": "#F5F5DC",
    "laguna": "#0057FF",
    "lead-free-pvd-brushed-stainless-steel": "#C0C0C0",
    "lf-brushed-brass": "#F5F5DC",
    "lf-brushed-carbon": "#000000",
    "lf-brushed-gold": "#D4AF37",
    "lf-brushed-nickel": "#C0C0C0",
    "lf-chrome": "#D0D0D0",
    "lf-gun-metal": "#808080",
    "lf-gunmetal": "#808080",
    "lf-matte-black": "#000000",
    "light-grey": "#D0D0D0",
    "matt-black": "#000000",
    "matt-bronze": "#000000",
    "matt-white": "#FFFFFF",
    "matte-alpine-white": "#FFFFFF",
    "matte-anthracite": "#001F5B",
    "matte-black": "#000000",
    "matte-chocolate": "#8B4513",
    "matte-chrome": "#C0C0C0",
    "matte-clay": "#8B4513",
    "matte-green": "#486A47",
    "matte-grey": "#808080",
    "matte-pink": "#FFC0CB",
    "matte-speckled": "#D0D0D0",
    "matte-white": "#FFFFFF",
    "mid-grey": "#808080",
    "midnight": "#001F5B",
    "midnight-sky": "#001F5B",
    "morning-green": "#9EA69F",
    "mirror-chrome": "#D0D0D0",
    "mirror-stainless-steel": "#C0C0C0",
    "natural-oak": "#CD7F32",
    "nero": "#000000",
    "night": "#000000",
    "nordic-brass": "#D4AF37",
    "nuvola": "#FFFFFF",
    "oceano": "#001F5B",
    "oiled-bronze": "#8B4513",
    "onyx": "#000000",
    "pergamon": "#FFFFFF",
    "pink": "#FFC0CB",
    "platinum": "#FFFFFF",
    "polar-white": "#FFFFFF",
    "polished-brass": "#D4AF37",
    "polished-chrome": "#D0D0D0",
    "polished-gold": "#FFA500",
    "polished-nickel": "#C0C0C0",
    "polished-nordic-brass": "#D4AF37",
    "polished-stainless-steel": "#C0C0C0",
    "prime-oak": "#8B4513",
    "pvd-aged-iron": "#001F5B",
    "pvd-brushed-brass": "#CD7F32",
    "pvd-brushed-bronze": "#CD7F32",
    "pvd-brushed-copper": "#CD7F32",
    "pvd-brushed-gold": "#D4AF37",
    "pvd-brushed-nickel": "#C0C0C0",
    "pvd-gold": "#FFA500",
    "pvd-gun-metal": "#4C4E51",
    "pvd-gunmetal": "#001F5B",
    "pvd-urban-brass": "#C9B480",
    "raw-brass": "#D4AF37",
    "red": "#F61F1F",
    "roma-bronze-pvd": "#8B4513",
    "rose-gold": "#D9BCC0",
    "rose-gold-pvd": "#B76E79",
    "sage": "#D0D0D0",
    "satin": "#C0C0C0",
    "satin-black": "#000000",
    "satin-nickel": "#C0C0C0",
    "satin-white": "#FFFFFF",
    "scandi-oak": "#D0D0D0",
    "semi-gloss-white": "#FFFFFF",
    "silver": "#D3D3D3",
    "slate": "#808080",
    "smoked-reflective": "#001F5B",
    "speckled-gloss-white": "#FFFFFF",
    "stainless-steel": "#C0C0C0",
    "statue-bronze": "#8B4513",
    "statue-bronze-pvd": "#8B4513",
    "stone": "#EC2828",
    "stone-grey": "#808080",
    "stone-white": "#FFFFFF",
    "sunset": "#CD7F32",
    "sunset-rose-gold": "#B76E79",
    "tempesta": "#808080",
    "urban-brass": "#D4AF37",
    "velato": "#C0C0C0",
    "warm-beige-20": "#F5F5DC",
    "warm-bronze": "#CD7F32",
    "warm-bronze-brushed-p-v-d": "#CD7F32",
    "warm-grey-10": "#FFFFFF",
    "warm-grey-60": "#808080",
    "white": "#FFFFFF",
    "white-satin": "#FFFFFF",
    "white-chrome": "#FFFFFF",
    "white-matte": "#FFFFFF",
    "white-onyx": "#FFFFFF",
    "white-chrome": "#FFFFFF",
    "white-gold": "#FFFFFF",
    "yellow": "#FFE500",
    "zolfo": "#FFFF00"
  };

  /**
   * Simple hash function for fallback colors
   */
  function hashCode(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = ((hash << 5) - hash) + str.charCodeAt(i);
      hash = hash & hash;
    }
    return Math.abs(hash);
  }

  /**
   * Find color from lookup table
   */
  function findColor(colorName) {
    // Convert to handle format (lowercase, hyphens)
    const handle = colorName.toLowerCase().trim().replace(/\s+/g, '-');
    
    // Exact match
    if (swatchColors[handle]) {
      return swatchColors[handle];
    }
    
    // Try without special characters
    const cleanHandle = handle.replace(/[^a-z0-9-]/g, '');
    if (swatchColors[cleanHandle]) {
      return swatchColors[cleanHandle];
    }
    
    // Partial match (for variants like "brushed-rose-gold-123")
    for (const [key, color] of Object.entries(swatchColors)) {
      if (handle.includes(key) || key.includes(handle)) {
        return color;
      }
    }
    
    return null;
  }

  /**
   * Get color - from lookup or generate fallback
   */
  function getColor(name) {
    const found = findColor(name);
    if (found) return found;

    // Fallback: generate from hash
    const hash = hashCode(name.toLowerCase());
    return `hsl(${hash % 360}, ${40 + (hash % 30)}%, ${45 + (hash % 20)}%)`;
  }

  /**
   * Get contrast color for text
   */
  function getContrastColor(bgColor) {
    if (bgColor.startsWith('#')) {
      const hex = bgColor.slice(1);
      const r = parseInt(hex.substr(0, 2), 16);
      const g = parseInt(hex.substr(2, 2), 16);
      const b = parseInt(hex.substr(4, 2), 16);
      const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
      return luminance > 0.5 ? '#000000' : '#ffffff';
    }
    if (bgColor.startsWith('hsl')) {
      const match = bgColor.match(/hsl\(\d+,\s*\d+%,\s*(\d+)%\)/);
      return match && parseInt(match[1]) > 55 ? '#000000' : '#ffffff';
    }
    return '#ffffff';
  }

  /**
   * Process all swatches
   */
  function processSwatches() {
    document.querySelectorAll('.swatch[class*="has-background-colour-"]').forEach(swatch => {
      if (swatch.dataset.colorGenerated === 'true') return;

      const match = swatch.className.match(/has-background-colour-([^\s]+)/);
      if (!match) return;

      const colorName = match[1].replace(/-/g, ' ');
      const bgColor = getColor(colorName);
      
      swatch.style.backgroundColor = bgColor;
      swatch.style.color = getContrastColor(bgColor);
      swatch.dataset.colorGenerated = 'true';
    });
  }

  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processSwatches);
  } else {
    processSwatches();
  }

  // Watch for dynamic content
  new MutationObserver(() => processSwatches()).observe(document.body, {
    childList: true,
    subtree: true
  });

  window.processSwatchColors = processSwatches;
})();
